export const shell = {
  nav: {
    matches: 'Матчи',
    statistics: 'Статистика',
    players: 'Игроки',
    store: 'Магазин',
    banPresets: 'Пресеты банов',
    admin: 'Админка',
    analytics: 'Аналитика',
    permissions: 'Права и роли',
    tags: 'Теги игроков',
    catalogs: 'Каталоги',
    matchSettings: 'Настройки матчей',
    promoCodes: 'Промокоды',
    polls: 'Голосования',
    dedicatedKeys: 'Ключи серверов',
    accounting: 'Бухгалтерия'
  },
  pageTitle: {
    player: 'Игрок',
    match: 'Матч'
  },
  app: {
    steamValidationFailed: 'Не удалось подтвердить вход через Steam. Повторите авторизацию.',
    accessDenied: 'Нет доступа к разделу.',
    accountDisabled: 'Аккаунт отключен.',
    authError: (code: string) => `Ошибка авторизации: ${code}`,
    sessionFetchFailed: 'Не удалось получить текущую сессию.',
    sessionKicker: 'Сессия',
    checkingAccess: 'Проверяю доступ...',
    noPlayerProfileTitle: 'Нет игрового профиля',
    noPlayerProfileDescription: 'У вас нет привязанного игрового профиля. Войдите в кастомную игру для регистрации.',
    presetsForbiddenTitle: 'Нет доступа к пресетам банов',
    presetsForbiddenDescription: 'У вашей учётной записи нет прав на редактирование пресетов банов.'
  },
  auth: {
    loginRequiredTitle: 'Войдите, чтобы продолжить',
    adminLoginDescription: 'Этот раздел доступен только администраторам — сначала авторизуйтесь через Steam.',
    adminOnlyTitle: 'Раздел только для администраторов',
    adminOnlyDescription: 'У вашей учётной записи нет прав на просмотр этого раздела.'
  },
  catalog: {
    loadFailed: 'Не удалось загрузить каталог'
  },
  avatar: {
    online: 'Онлайн'
  },
  cookieBanner: {
    textPrefix: 'Сайт использует только необходимые cookie для входа и работы сессии.',
    link: 'Подробнее — в Политике',
    dismiss: 'Понятно'
  },
  dateInput: {
    placeholder: 'дд.мм.гггг'
  },
  systemStates: {
    errorTitle: 'Что-то пошло не так',
    forbiddenTitle: 'Нет доступа',
    forbiddenDescription: 'У вас недостаточно прав для просмотра этого раздела.',
    loadingTitle: 'Загрузка...',
    loginGateTitle: 'Войдите, чтобы продолжить',
    loginGateDescription: 'Для просмотра этого раздела необходима авторизация через Steam.',
    whatIsAvailable: 'Что доступно без логина?',
    readOnly: 'Только просмотр — изменения недоступны'
  },
  tableSkeleton: {
    ariaLabel: 'Загрузка данных'
  },
  legal: {
    documents: 'Правовая информация',
    documentsTitle: 'Документы',
    offer: 'Публичная оферта'
  },
  privacy: {
    kicker: 'Правовая информация',
    title: 'Политика обработки персональных данных',
    revision: (date: string) => `Редакция от ${date}`,
    operator: {
      title: '1. Оператор персональных данных и контакты',
      intro: (siteUrl: string) =>
        `Оператором персональных данных пользователей сайта ${siteUrl} (далее — «Сайт», «Сервис») является администрация сайта ratten.run.`,
      contactPrefix:
        'По вопросам обработки персональных данных, а также для отзыва согласия на обработку или запроса на удаление данных обращайтесь на email: ',
      contactSuffix: '.'
    },
    data: {
      title: '2. Какие данные обрабатываются',
      items: [
        'Steam ID пользователя, публичный никнейм и аватар Steam (получены через Steam OpenID при входе).',
        'Игровая статистика: результаты матчей, рейтинг (SOLO/DUO), теги игрока, история банов.',
        'Служебные данные сессии: refresh-токен (хранится в cookie), идентификатор сессии.',
        'Данные заказов в магазине: email, игровой UID (только для VIP-подписки), номер, состав, сумма и статус заказа. Данные банковских карт Сайт не получает и не хранит.',
        'Технические логи запросов: IP-адрес, User-Agent, идентификатор запроса.'
      ]
    },
    purposes: {
      title: '3. Цели обработки',
      items: [
        'Идентификация и аутентификация пользователя через Steam.',
        'Предоставление функций Сервиса: отображение статистики, рейтингов, истории матчей.',
        'Поддержание работы игровой сессии и защита от несанкционированного доступа.',
        'Модерация: обработка тегов, банов и жалоб.',
        'Оформление и исполнение заказов в магазине: выдача кода или ключа, активация подписки, отправка писем о заказе, формирование чеков, ответы на обращения и возвраты.',
        'Диагностика технических неполадок и обеспечение безопасности Сервиса.'
      ]
    },
    legalBasis: {
      title: '4. Правовые основания обработки',
      text: 'Обработка осуществляется на основании согласия пользователя (выражается действием — входом через Steam), а также в целях исполнения условий использования Сервиса и договора о предоставлении цифровых услуг (публичной оферты магазина) и на основании законных интересов оператора (обеспечение безопасности, предотвращение мошенничества и нарушений правил игры).'
    },
    storage: {
      title: '5. Способы и сроки хранения данных',
      text: 'Данные хранятся в электронном виде на сервере, расположенном на территории Российской Федерации (хостинг-провайдер FirstVDS). Игровая статистика и профиль хранятся на протяжении использования Сервиса. Refresh-токен сессии хранится в cookie до 90 дней или до выхода из аккаунта. Данные заказов хранятся не дольше, чем требуется для исполнения заказа, возвратов и требований законодательства, затем удаляются или обезличиваются. Технические логи хранятся ограниченный срок, необходимый для диагностики и безопасности.'
    },
    thirdParties: {
      title: '6. Передача данных третьим лицам',
      valveName: 'Valve Corporation (Steam)',
      valveText:
        '— используется как внешний провайдер входа по протоколу OpenID. Сервис получает от Steam только Steam ID, публичный никнейм и аватар; пароль от Steam Сервису не передаётся и не хранится.',
      hostingName: 'Хостинг-провайдер',
      hostingText:
        '— сервер, на котором размещены Сайт и база данных, находится на территории РФ (FirstVDS).',
      paymentName: 'Платёжные сервисы',
      paymentText:
        '— получают данные, необходимые для проведения оплаты (сумма, номер заказа, email для чека). Данные банковской карты вводятся на стороне платёжного сервиса и оператору не передаются.',
      mailName: 'Почтовый сервис',
      mailText: '— используется для отправки писем о заказе (email и содержимое письма).',
      gameName: 'Игровой сервер и бот-менеджер Ratten Run',
      gameText: '— получают игровой UID для активации подписки и выдачи покупки.',
      noOthers: 'Иным третьим лицам персональные данные не передаются, в рекламных или маркетинговых целях не используются.'
    },
    rights: {
      title: '7. Права субъекта персональных данных',
      lead: 'Пользователь вправе:',
      items: [
        'получить информацию о составе и целях обработки своих данных;',
        'отозвать согласие на обработку персональных данных;',
        'потребовать удаления, уточнения или блокировки своих данных.'
      ],
      requestPrefix: 'Для реализации этих прав направьте запрос на email оператора',
      requestSuffix:
        '. Обращаем внимание: отзыв согласия или удаление данных может сделать невозможным дальнейшее использование Сервиса (например, вход через Steam или отображение игровой статистики).'
    },
    cookies: {
      title: '8. Файлы cookie',
      text: 'Сайт использует только строго необходимые файлы cookie, обеспечивающие вход и работу сессии. Аналитические и рекламные cookie не используются.',
      columnName: 'Название',
      columnPurpose: 'Назначение',
      columnRetention: 'Срок хранения',
      sessionPurpose: 'Идентификатор HTTP-сессии на сервере',
      sessionRetention: 'До закрытия сессии / браузера',
      refreshPurpose:
        'Продление сессии входа без повторной авторизации через Steam (httpOnly, недоступен из JS)',
      refreshRetention: 'До 90 дней или до выхода из аккаунта',
      localStorage:
        'Также Сайт хранит в локальном хранилище браузера (localStorage) факт закрытия информационного уведомления о cookie, а также номера заказов и токены доступа к ним для проверки статуса заказа — эти данные не покидают ваше устройство и не передаются на сервер. Кроме того, хранится rr_visitor_id — случайный идентификатор для подсчёта посетителей онлайн: он не связан с вашим аккаунтом, передаётся на сервер и хранится там не дольше нескольких минут.'
    },
    changes: {
      title: '9. Изменения политики',
      prefix: 'Оператор вправе изменять настоящую Политику. Актуальная редакция всегда доступна по адресу',
      suffix: '. Дата редакции указана в начале документа.'
    }
  }
};
